export default __webpack_public_path__ + "static/media/bigtime-shadow.e68c5bd1.svg";